module.exports = __webpack_public_path__ + "img/info-icon.879ada1f.svg";